S.sliderGallery =
    {
        elements: {
            $container: null,
        },

        init()
        {
            this.initSlider();

        },
        initSlider() {

            if (this.elements.$container.children().length === 1) {
                this.elements.$container.magnificPopup({
                    type: 'image',
                    delegate: 'a',
                });
            }
            else {
                this.elements.$container.magnificPopup({
                    type: 'image',
                    delegate: 'a',
                    gallery:{enabled:true},
                    callbacks: {
                        buildControls: function() {
                            this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                        },
                    },
                });
            }
        },

    };
